import { BaseModal } from "../../components/modalCommon/modalBase";
import { ModalBody } from "../../components/modalCommon/modalBody";
import { ModalFooter } from "../../components/modalCommon/modalFooter";
import { ModalHeader } from "../../components/modalCommon/modalHeader";
import { TestParametersContent } from "../../pages/tonal-audiometry/tonal-panels/testParameters";
import type { TonalTestParamsModalProps } from "../../type/tonalTest";
import { useI18n } from "../../utils/translate/i18n/useI18n";

export default function TestParamsModal({
  isOpen,
  onClose,
  addNoise,
  continuous,
  randomTest,
  adaptiveTest,
  gender,
  ageCategory,
  onToggleAddNoise,
  onToggleContinuous,
  onToggleRandomTest,
  onToggleAdaptiveTest,
  onChangeGender,
  onChangeAgeCategory,
}: TonalTestParamsModalProps) {
  const { t } = useI18n();

  return (
    <BaseModal open={isOpen} onClose={onClose} size="md">
      <ModalHeader title={t("Parametry testu")} onClose={onClose} />
      <ModalBody>
        <TestParametersContent
          addNoise={addNoise}
          continuous={continuous}
          randomTest={randomTest}
          adaptiveTest={adaptiveTest}
          gender={gender}
          ageCategory={ageCategory}
          onToggleAddNoise={onToggleAddNoise}
          onToggleContinuous={onToggleContinuous}
          onToggleRandomTest={onToggleRandomTest}
          onToggleAdaptiveTest={onToggleAdaptiveTest}
          onChangeGender={onChangeGender}
          onChangeAgeCategory={onChangeAgeCategory}
        />
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-primary px-4" onClick={onClose}>
          {t("OK")}
        </button>
      </ModalFooter>
    </BaseModal>
  );
}
